import { render, staticRenderFns } from "./CampaignInviteDialog.vue?vue&type=template&id=10faae06&scoped=true"
import script from "./CampaignInviteDialog.vue?vue&type=script&lang=js"
export * from "./CampaignInviteDialog.vue?vue&type=script&lang=js"
import style0 from "./CampaignInviteDialog.vue?vue&type=style&index=0&id=10faae06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10faae06",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VChip,VCombobox,VSwitch})
